import styled from "styled-components";

import { Switcher } from "@similarweb/ui-components";

import {
    BodyWrapper,
    WidgetFooterContainer,
    WidgetHeaderContainer,
} from "app/components/React/WidgetContainer/styledComponents";

export const TableWrapper = styled.div`
    width: calc(50% - 12px);
    height: 408px;
    ${BodyWrapper} {
        min-height: 293px;
        height: auto;
        flex: 1;
        overflow: hidden;
    }
    ${WidgetFooterContainer} {
        border-top: 0;
    }
    ${WidgetHeaderContainer} {
        padding-bottom: 16px;
    }
    .noDataTable {
        padding: 24px 0;
        > div:last-child {
            margin-top: 5px;
        }
    }
`;

export const SwitcherWrapper = styled(Switcher)`
    margin-bottom: 16px;
    padding-left: 24px;
`;
